import Cookies from "js-cookie";

export function isAdmin() {
  return !!Cookies.get("admin");
}

export function isAssumed() {
  return !!Cookies.get("asmd");
}
